// import React from 'react';
// import Header from './components/Header/Header';
// import Navbar from './components/Navbar/Navbar';
// import Home from './components/Home/Home';
// import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import ProductList from './components/ProductList/ProductList';
// import Footer from './components/Footer/Footer';
// import ContactForm from './components/ContactForm/ContactForm';
// import Login from './components/Login/Login';
// import Signup from './components/Signup/Signup';
// import AdminDashboard from './components/AdminDashboard/AdminDashboard';
// import UserDashboard from './components/UserDashboard/UserDashboard';
// import ForgotPassword from './components/Signup/ForgotPassword';
// import ResetPassword from './components/Signup/Resertpassword';



// const App = () => {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// };

// const AppContent = () => {
//   const location = useLocation(); 
//   const isLoggedIn = sessionStorage.getItem('email');

//   const ProtectedRoute = ({ children }) => {
//     if (!isLoggedIn) {
//       return <Navigate to="/login" />;
//     }
//     return children; 
//   };

//   const shouldShowHeaderNavbarFooter = location.pathname !== '/ForgotPassword' && location.pathname !== '/reset-password' && location.pathname !== '/user-dashboard' && location.pathname !== '/admin-dashboard';


//   return (
//     <div className="font-sans bg-gray-50">
//      {shouldShowHeaderNavbarFooter && (
//         <>
//           <Header />
//           <Navbar />
//         </>
//       )}

//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/products" element={<ProductList />} />
//         <Route path="/contact" element={<ContactForm />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
// <Route path="/ForgotPassword" element={<ForgotPassword />} />
// <Route path="/reset-password" element={<ResetPassword />} />

//         <Route
//           path="/user-dashboard"
//           element={
//             <ProtectedRoute>
//               <UserDashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/admin-dashboard"
//           element={
//             <ProtectedRoute>
//               <AdminDashboard />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>

//       {/* Conditionally render Footer */}
//       {shouldShowHeaderNavbarFooter  && <Footer />}
//     </div>
//   );
// };

// export default App;



import React, { useState } from 'react';
import Header from './components/Header/Header';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate,  useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductList from './components/ProductList/ProductList';
import Footer from './components/Footer/Footer';
import ContactForm from './components/ContactForm/ContactForm';
import Login from './components/Login/Login';
import Signup from './components/Signup/Signup';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import UserDashboard from './components/UserDashboard/UserDashboard';
import ForgotPassword from './components/Signup/ForgotPassword';
import ResetPassword from './components/Signup/Resertpassword';
import Delete from './components/Delete/Delete';
import InvitationResponse from './components/UserDashboard/InvitationResponse';
import WhatsappLogin from './components/Login/WhatsappLogin';
import ChapterAdminDashboard from './components/AdminDashboard/ChapterAdminDashboard';
import MemberFlyerLogin from './components/MemberFlyer/MemberFlyerLogin';
import MemberFlyerHome from './components/MemberFlyer/MemberFlyerHome';
import MemberProducts from './components/MemberFlyer/MemberProducts';
import PrivateRoute from "./components/MemberFlyer/PrivateRoute";
import FlyerAdminLogin from './components/MemberFlyer/FlyerAdminLogin';
import FlyerAdminDashboard from './components/MemberFlyer/FlyerAdminDashboard';
import ProtectedAdminRoute from './components/MemberFlyer/ProtectedAdminRoute';
import VisitorForm from './components/UserDashboard/VisitorForm';
import EventRegistrationForm from './components/EventForm/EventRegistrationForm';
// import "leaflet/dist/leaflet.css";


import AdminLogin from './components/Auth/AdminLogin';
import MemberForm from './components/forms/MemberForm';
import { LogOut } from 'lucide-react';
import SupplierForm from './components/forms/SupplierForm';

import DigitalCardView from './components/Admin/DigitalCardView';
import SupplierOffers from './components/suppliers/SupplierOffers';
import SupplierLogin from './components/Auth/SupplierLogin';
import SupplierDashboard from './components/suppliers/SupplierDashboard';
import AdminDashboardd from './components/Admin/AdminDashboard';




function SupplierLoginWrapper({ onLoginSuccess }) {
  const navigate = useNavigate();
  return (
    <SupplierLogin
      onLoginSuccess={(sup) => {
        onLoginSuccess(sup);
        navigate('/supplier/dashboard');
      }}
    />
  );
}


// Wrapper for Admin Login with Instant Redirect
function AdminLoginWrapper({ onLoginSuccess }) {
  const navigate = useNavigate();

  const handleSuccess = (adminData) => {
    onLoginSuccess(adminData);
    navigate('/admin/dashboard');
  };

  return <AdminLogin onLoginSuccess={handleSuccess} />;
}




const App = () => {
  


  return (
    <Router>
      <AppContent /> {/* We call the AppContent here, which will contain the logic for header/footer rendering */}
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation(); // Get the current route
  const isLoggedIn = sessionStorage.getItem('email'); // Check if the user is logged in (example: checking sessionStorage)

 const [currentAdmin, setCurrentAdmin] = useState(() => {
    const saved = localStorage.getItem('privilege_admin');
    return saved ? JSON.parse(saved) : null;
  });


  // Supplier Session
  const [currentSupplier, setCurrentSupplier] = useState(() => {
    const saved = localStorage.getItem('privilege_supplier');
    return saved ? JSON.parse(saved) : null;
  });



  const handleLoginSuccess = (adminData) => {
    setCurrentAdmin(adminData);
    localStorage.setItem('privilege_admin', JSON.stringify(adminData));
  };

  const handleLogout = () => {
    setCurrentAdmin(null);
    localStorage.removeItem('privilege_admin');
  };

  const handleSupplierLogin = (data) => {
    setCurrentSupplier(data);
    localStorage.setItem('privilege_supplier', JSON.stringify(data));
  };

  const handleSupplierLogout = () => {
    setCurrentSupplier(null);
    localStorage.removeItem('privilege_supplier');
  };

  const handleSupplierUpdate = (updated) => {
    setCurrentSupplier(updated);
    localStorage.setItem('privilege_supplier', JSON.stringify(updated));
  };


  // Function to protect routes
  const ProtectedRoute = ({ children }) => {
    if (!isLoggedIn) {
      // If not logged in, redirect to login page
      return <Navigate to="/login" />;
    }
    return children; // If logged in, render the child components (protected route content)
  };

  return (
    <div className="font-sans bg-gray-50">
      {/* Conditionally render Header, Navbar, and Footer */}
      {(location.pathname !== '/user-dashboard' && location.pathname !== '/VisitorRegistrationForm' && location.pathname !== '/admin-dashboard' && location.pathname !== '/reset-password'&& location.pathname !== '/chapter-admin-dashboard') && location.pathname !=='/flyer-login' && location.pathname !=='/memberflyer' &&   !location.pathname.startsWith('/member-products/')
 && location.pathname !=="/flyer-admin" && location.pathname !=="/flyer-admin-dashboard" && location.pathname !== '/admin/login' && location.pathname !=="/supplier/login" && location.pathname !=="/supplier/dashboard" && location.pathname !=="/admin/dashboard" &&(
        <>
          <Header />
          <Navbar />
        </>
      )}

      {/* Define the routes using Routes and Route */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/login" element={<Login />} />
         <Route path="/whatsappLogin" element={<WhatsappLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/delete" element={<Delete />} />
        <Route path="/invitations/:id" element={<InvitationResponse />} /> 
        <Route path="/EventRegistrationForm" element={<EventRegistrationForm />} /> 
          <Route path="/flyer-login" element={<MemberFlyerLogin />} /> 
 <Route path="/VisitorRegistrationForm" element={<VisitorForm />} />
 
  <Route
    path="/memberflyer"
    element={
      <PrivateRoute>
        <MemberFlyerHome />
      </PrivateRoute>
    }
  />



  <Route
    path="/member-products/:email"
    element={
      <PrivateRoute>
        <MemberProducts />
      </PrivateRoute>
    }
  />
  <Route path="/flyer-admin" element={<FlyerAdminLogin/>}/>
<Route
  path="/flyer-admin-dashboard"
  element={
    <ProtectedAdminRoute>
      <FlyerAdminDashboard/>
    </ProtectedAdminRoute>
  }
/>

        {/* Protected Route for User Dashboard */}
        <Route
          path="/user-dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />

        {/* Protected Route for Admin Dashboard */}
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
          <Route
          path="/chapter-admin-dashboard"
          element={
            <ProtectedRoute>
              <ChapterAdminDashboard />
            </ProtectedRoute>
          }
        />
              <Route path="/member-form" element={<MemberForm />} />
            <Route path="/member-onboard" element={<MemberForm />} />
            <Route path="/supplier-onboard" element={<SupplierForm />} />
            <Route path="/card/view/:code" element={<DigitalCardView />} />
            <Route path="/offers" element={<SupplierOffers />} />

            {/* Direct Admin Login Route */}
            <Route
              path="/admin/login"
              element={
                currentAdmin ? (
                  <Navigate to="/admin/dashboard" replace />
                ) : (
                  <AdminLoginWrapper onLoginSuccess={handleLoginSuccess} />
                )
              }
            />


            <Route
          path="/supplier/login"
          element={currentSupplier ? <Navigate to="/supplier/dashboard" replace /> : <SupplierLoginWrapper onLoginSuccess={handleSupplierLogin} />}
        />
        <Route
          path="/supplier/dashboard"
          element={
            currentSupplier ? (
              <SupplierDashboard
                currentSupplier={currentSupplier}
                onLogout={handleSupplierLogout}
                onUpdateSupplier={handleSupplierUpdate}
              />
            ) : (
              <Navigate to="/supplier/login" replace />
            )
          }
        />

            {/* Direct Protected Admin Dashboard Route */}
            <Route
              path="/admin/dashboard"
              element={
                currentAdmin ? (
                  <AdminDashboardd currentAdmin={currentAdmin} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/admin/login" replace />
                )
              }
            />

      </Routes>

      {/* Conditionally render Footer */}
      {(location.pathname !== '/user-dashboard' && location.pathname !== '/VisitorRegistrationForm' && location.pathname !== '/admin-dashboard' && location.pathname !== '/chapter-admin-dashboard') &&   location.pathname !=='/flyer-login' && location.pathname !=='/memberflyer' &&   !location.pathname.startsWith('/member-products/')
 && location.pathname !=="/flyer-admin" && location.pathname !=="/flyer-admin-dashboard" && location.pathname !== '/admin/login' &&   location.pathname !=="/supplier/login" && location.pathname !=="/supplier/dashboard" && location.pathname !=="/admin/dashboard" &&<Footer />}
    </div>
  );
};

export default App;